import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  TextField as MuiTextField,
  Autocomplete as MuiAutocomplete,
} from "@mui/material";
import { getAllUnits } from "app/services/commitmentsService";

export const CommitmentUnitField = ({
  required,
  error,
  helperText,
  ...passedParams
}) => {
  const { t } = useTranslation();

  // Units
  const [units, setUnits] = useState([]);

  const [unitError, setUnitError] = useState({
    exist: false,
    message: null,
  });

  useEffect(() => {
    const cancelSource = axios.CancelToken.source();

    getAllUnits(setUnits, setUnitError, cancelSource);
    return () => {
      cancelSource.cancel();
    };
  }, []);

  return (
    <>
      {units && (
        <MuiAutocomplete
          options={units}
          getOptionLabel={(option) => option && option.name}
          autoHighlight
          disableClearable
          handleHomeEndKeys
          openOnFocus
          fullWidth
          clearIcon={false}
          required={required}
          renderInput={(params) => (
            <MuiTextField
              {...params}
              label={t(`Commitments.create.form.fields.commitmentUnit.label`)}
              required={required}
              error={unitError.exist || error}
              helperText={unitError.message || helperText}
              slotProps={{
                ...params.slotProps,

                htmlInput: {
                  ...params.slotProps.htmlInput,
                  autoComplete: "off",
                },
              }}
            />
          )}
          {...passedParams}
        />
      )}
    </>
  );
};
